var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-editor-container" },
    [
      _c("panel-group", {
        attrs: { metrics: _vm.metrics },
        on: { "handle-set-line-chart-data": _vm.handleSetLineChartData },
      }),
      _c(
        "el-row",
        {
          staticStyle: {
            background: "#fff",
            padding: "16px 16px 0",
            "margin-bottom": "32px",
          },
        },
        [
          _c("div", { staticClass: "order-table-title" }, [
            _c("div", [_vm._v(_vm._s(_vm.title))]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.listLoading,
                    expression: "!listLoading",
                  },
                ],
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchValue.value,
                      expression: "searchValue.value",
                    },
                  ],
                  staticStyle: { width: "150px" },
                  attrs: { type: "text", size: "mini", placeholder: "Search" },
                  domProps: { value: _vm.searchValue.value },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.handleSearch.apply(null, arguments)
                    },
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.searchValue, "value", $event.target.value)
                    },
                  },
                }),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "5px" },
                    attrs: {
                      title: "search",
                      type: "success",
                      size: "mini",
                      icon: "el-icon-search",
                      bold: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleSearch()
                      },
                    },
                  },
                  [_vm._v("Search")]
                ),
                _c("el-button", {
                  staticStyle: { "margin-left": "5px" },
                  attrs: {
                    title: "clear",
                    type: "warning",
                    size: "mini",
                    icon: "el-icon-delete",
                    plain: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleReset()
                    },
                  },
                }),
              ],
              1
            ),
            _c("div", [_vm._v(_vm._s(_vm.total) + " Orders")]),
          ]),
          _c("OrderTable", {
            attrs: {
              list: _vm.list,
              listLoading: _vm.listLoading,
              total: _vm.total,
            },
            on: { handleDelete: _vm.handleDelete },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }